'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _values2 = require('lodash/values');

var _values3 = _interopRequireDefault(_values2);

var _round2 = require('lodash/round');

var _round3 = _interopRequireDefault(_round2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.getElements = getElements;
exports.getElementLayout = getElementLayout;
exports.paddedHex = paddedHex;
exports.getLinearGradientAngle = getLinearGradientAngle;
exports.radToDeg = radToDeg;
exports.getTransformations = getTransformations;
exports.divideValues = divideValues;

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function getElements(canvas, isCanvas) {
  var flatCanvas = [];
  var clonedCanvas = (0, _cloneDeep3.default)(canvas);
  clonedCanvas.children.forEach(function (child) {
    return flattenItem(flatCanvas, child);
  }); // Calculate element layout up-front

  var _canvas$artboard$desi = canvas.artboard.designRatio,
      designRatio = _canvas$artboard$desi === undefined ? 1 : _canvas$artboard$desi;
  flatCanvas.forEach(function (element, i) {
    // eslint-disable-next-line no-param-reassign
    element.id = i;
    applyDesignRatio(element, designRatio);
    removeEmptyBordersAndShadows(element);
    applyFillsHack(element);

    if (isCanvas) {
      applyAssetsHack(element);
    } // eslint-disable-next-line no-param-reassign


    element.layout = getElementLayout(designRatio, element);
  });
  return flatCanvas;
}

function flattenItem(flatCanvas, item) {
  if (!isSupported(item)) {
    return;
  }

  if (item.className === 'Mask') {
    // TODO why is this needed?
    if (item.children.length) {
      // eslint-disable-next-line no-param-reassign
      item.size = item.children[0].size;
    } else {
      // eslint-disable-next-line no-param-reassign
      item.size = [0, 0];
    }
  }

  if (item.className !== 'Group' && item.className !== 'Mask' || item.itemProps.isExportable) {
    flatCanvas.push(item);
  }

  if (item.children) {
    item.children.forEach(function (child) {
      // eslint-disable-next-line no-param-reassign
      child.positionParent = item; // eslint-disable-next-line no-param-reassign

      child.parent = getExportableParent(item);
      flattenItem(flatCanvas, child);
    });
  }
}

function removeEmptyBordersAndShadows(element) {
  if (element.strokes && element.strokes.length > 0) {
    // eslint-disable-next-line no-param-reassign
    element.strokes = element.strokes.filter(function (stroke) {
      return stroke.width !== 0;
    });
  }

  if (element.shadows && element.shadows.length > 0) {
    // eslint-disable-next-line no-param-reassign
    element.shadows = element.shadows.filter(function (shadow) {
      return !isEmptyShadow(shadow);
    });
  }

  if (element.innerShadows && element.innerShadows.length > 0) {
    // eslint-disable-next-line no-param-reassign
    element.innerShadows = element.innerShadows.filter(function (shadow) {
      return !isEmptyShadow(shadow);
    });
  }
}

function isEmptyShadow(_ref) {
  var shadowSpread = _ref.shadowSpread,
      offset = _ref.offset,
      blur = _ref.blur;
  return shadowSpread === 0 && offset[0] === 0 && offset[1] === 0 && blur === 0;
}

function applyFillsHack(element) {
  // https://marvelapp.atlassian.net/browse/ES-1548
  if (element.fills) {
    // eslint-disable-next-line no-param-reassign
    element.fillStyle = {
      fillRule: 'nonzero',
      // ???
      fills: element.fills
    };
  }
}

function applyAssetsHack(element) {
  // Canvas does not support exportable layers yet so we make *all*
  // rasters exportable by adding an entry to the assets array
  if (element.source) {
    var assetName = _path2.default.basename(element.source); // eslint-disable-next-line no-param-reassign


    element.itemProps.assets = [{
      suffix: '',
      name: assetName,
      format: 'UNKNOWN',
      scale: 1,
      prefix: '',
      url: element.source
    }];
  }
}

function getElementLayout(designRatio, element) {
  var partialLayout = void 0;

  if (element.className === 'Group') {
    partialLayout = Object.assign({}, getGroupLayout(designRatio, element));
  } else {
    var matrices = [];
    var parent = element;

    while (parent) {
      matrices.splice(0, 0, parent.itemProps.matrix);
      parent = parent.positionParent;
    }

    var baseMatrix = [1 / designRatio, 0, 0, 1 / designRatio, 0, 0];
    var matrix = matrices.reduce(multiplyMatrices, baseMatrix);
    var boundingBox = [[0, 0], [element.size[0], 0], [0, element.size[1]], [element.size[0], element.size[1]]];
    var transformed = boundingBox.map((0, _partial3.default)(transformPoint, matrix));
    partialLayout = {
      top: transformed[0].y,
      left: transformed[0].x,
      right: transformed[1].x,
      bottom: transformed[3].y
    };
  } // This is crashing easel with 4839514097211029191

  /* let ancestor = element;
   * while (ancestor) {
   *   if (
   *     // isTheThingBeingMasked
   *     false &&
   *     ancestor.positionParent &&
   *     ancestor.positionParent.className === 'Mask' &&
   *     element !== ancestor.positionParent.children[0]
   *   ) {
   *     const maskLayout = getElementLayout(
   *       designRatio,
   *       ancestor.positionParent.children[0]
   *     );
   *     // intersect
   *     partialLayout.left = Math.max(maskLayout.left, partialLayout.left);
   *     partialLayout.top = Math.max(maskLayout.top, partialLayout.top);
   *     partialLayout.right = Math.min(maskLayout.right, partialLayout.right);
   *     partialLayout.bottom = Math.min(maskLayout.bottom, partialLayout.bottom);
   *   }
   *   ancestor = ancestor.positionParent;
   * }*/


  var roundedLayout = (0, _mapValues3.default)(partialLayout, function (v) {
    return (0, _round3.default)(v, 2);
  });
  var layout = Object.assign({}, roundedLayout, {
    x: roundedLayout.left,
    y: roundedLayout.top,
    width: (0, _round3.default)(partialLayout.right - partialLayout.left, 2),
    height: (0, _round3.default)(partialLayout.bottom - partialLayout.top, 2)
  });
  return layout;
}

function getGroupLayout(designRatio, group) {
  var childLayouts = group.children.map((0, _partial3.default)(getElementLayout, designRatio));
  return {
    left: Math.min.apply(Math, _toConsumableArray(childLayouts.map(function (l) {
      return l.left;
    }))),
    top: Math.min.apply(Math, _toConsumableArray(childLayouts.map(function (l) {
      return l.top;
    }))),
    right: Math.max.apply(Math, _toConsumableArray(childLayouts.map(function (l) {
      return l.right;
    }))),
    bottom: Math.max.apply(Math, _toConsumableArray(childLayouts.map(function (l) {
      return l.bottom;
    })))
  };
}

function transformPoint(matrix, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      x = _ref3[0],
      y = _ref3[1];

  return {
    x: x * matrix[0] + y * matrix[2] + matrix[4],
    y: x * matrix[1] + y * matrix[3] + matrix[5]
  };
}

function multiplyMatrices(matrix1, matrix2) {
  var _matrix = _slicedToArray(matrix1, 6),
      a1 = _matrix[0],
      b1 = _matrix[1],
      c1 = _matrix[2],
      d1 = _matrix[3],
      tx1 = _matrix[4],
      ty1 = _matrix[5];

  var _matrix2 = _slicedToArray(matrix2, 6),
      a2 = _matrix2[0],
      b2 = _matrix2[1],
      c2 = _matrix2[2],
      d2 = _matrix2[3],
      tx2 = _matrix2[4],
      ty2 = _matrix2[5];

  return [a2 * a1 + c2 * c1, b2 * a1 + d2 * c1, a2 * b1 + c2 * d1, b2 * b1 + d2 * d1, tx1 + (tx2 * a1 + ty2 * c1), ty1 + (tx2 * b1 + ty2 * d1)];
}

var supportedElementClasses = ['Group', 'Raster', 'Text', 'Shape', 'Mask'];

function isSupported(element) {
  return supportedElementClasses.includes(element.className);
}

function getExportableParent(item) {
  while (item && !item.itemProps.isExportable) {
    // eslint-disable-next-line no-param-reassign
    item = item.parent;
  }

  return item;
}

function paddedHex(hexValue) {
  var leftPad = '';

  if (hexValue < 16) {
    leftPad = '0';
  }

  return '' + leftPad + hexValue.toString(16);
}

function getLinearGradientAngle(from, to) {
  // Note y coord is flipped as sketch y-axis positive direction is _downwards_
  var angle = (0, _round3.default)(radToDeg(Math.atan2(to[0] - from[0], from[1] - to[1])), 2);

  if (angle < 0) {
    angle += 360;
  }

  return angle;
}

function radToDeg(rad) {
  return rad * 180 / Math.PI;
}

function getTransformations(transformations, selectedTransformations) {
  return (0, _values3.default)((0, _pick3.default)(transformations, selectedTransformations));
}

function applyDesignRatio(item, designRatio) {
  /* eslint-disable no-param-reassign */
  if (item.radius) {
    item.radius = divideValues(item.radius, designRatio);
  }

  if (item.style) {
    var style = item.style;
    ['fontSize', 'letterSpacing', 'lineHeight'].forEach(function (prop) {
      style[prop] /= designRatio;
    });
  }

  var itemProps = item.itemProps;

  if (itemProps) {
    if (itemProps.blur) {
      itemProps.blur /= designRatio;
    }
  }

  ['shadows', 'innerShadows'].forEach(function (shadows) {
    if (item[shadows]) {
      item[shadows].forEach(function (shadow) {
        shadow.shadowSpread /= designRatio;
        shadow.offset = divideValues(shadow.offset, designRatio);
        shadow.blur /= designRatio;
      });
    }
  });

  if (item.strokes) {
    item.strokes.forEach(function (stroke) {
      stroke.width /= designRatio;
    });
  }

  if (item.strokeStyle) {
    var strokeStyle = item.strokeStyle;

    if (strokeStyle.dashArray) {
      strokeStyle.dashArray = divideValues(strokeStyle.dashArray, designRatio);
    }
  }
  /* eslint-enable no-param-reassign */

}

function divideValues(values_, divisor) {
  return values_.map(function (v) {
    return v / divisor;
  });
}